import { defineMessages } from 'react-intl';

export const messages: {
	line1: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	line2: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mostPopularAppName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noDataLine1: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noDataLine2: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	line1: {
		id: 'twg-microsite.userHighlight.line1',
		defaultMessage:
			"G'day {name}, here's your <graphName>{twg_branding}</graphName> overview. Your graph has <itemsContributed></itemsContributed> items contributed by <peopleCount></peopleCount> people. From that, we've created <relationshipsCount></relationshipsCount> relationships across <appCount></appCount> apps.",
		description:
			'Introductory text before item and people counts. {twg_branding} is the product brand name.',
	},
	line2: {
		id: 'twg-microsite.userHighlight.line2',
		defaultMessage:
			"It's clear <mostPopularApp></mostPopularApp> is a crowd favourite, responsible for {mostPopularAppContributions} of your {itemsContributed} items. You can explore more of a breakdown plus a visual preview of your graph below.",
		description: 'Link to the app in the email {twg_branding} is the product brand name.',
	},
	mostPopularAppName: {
		id: 'twg-microsite.userHighlight.mostPopularAppName',
		defaultMessage: 'Figma',
		description: 'Name of the user’s most-used app shown inline in the highlight copy',
	},
	noDataLine1: {
		id: 'twg-microsite.userHighlight.noDataLine1',
		defaultMessage: "G'day {name},",
		description: 'Introductory text before item and people counts',
	},
	noDataLine2: {
		id: 'twg-microsite.userHighlight.noDataLine2',
		defaultMessage:
			"Looks like your <graphName>{twg_branding}</graphName> is only just getting started. Your team hasn't indexed enough for us to provide a report just yet. Never fear, here's some great ways to start connecting your work so we can get your graph humming.",
		description:
			'Introductory text after the greeting on the empty / no-data state. {twg_branding} is the product brand name.',
	},
});
